export default {
  loadingAnalysis: 'Loading analysis...',
  generatingAnalysis: 'Generating analysis...',
  regenerating: 'Regenerating...',
  regenerateAnalysis: 'Regenerate analysis',
  regenerateConfirmMessage: 'A new report will be generated and will replace the current one. Do you want to continue?',
  regenerateConfirmTitle: 'Regenerate report',
  confirmRegenerate: 'Yes, regenerate',
  cancelRegenerate: 'No, keep current',
  adjustParameters: 'Adjust analysis parameters',
  parameters: 'Parameters',
  analysisParameters: 'Analysis parameters',
  temperatureLabel: 'Temperature (creativity):',
  temperatureHint: 'Recommended: 0.2 for precise analysis',
  maxTokensLabel: 'Maximum tokens:',
  maxTokensHint: 'Recommended: 6000 for complete analysis',
  analysisResult: 'Analysis result:',
  printReport: 'Print report',
  print: 'Print',
  requestedBy: 'Requested by:',
  updatedAt: 'Updated:',
  cancelConfirmMessage: 'The analysis is in progress. Do you want to cancel it?',
  cancelGeneration: 'Cancel generation',
  confirmCancel: 'Yes, cancel',
  continueGeneration: 'No, continue',
  tokenLimitError: 'The analysis may be incomplete due to token limit.',
  generateError: 'Error generating the report. Please try again.',
}
